import React from 'react';
import './GetReady.css';
import VisibilitySensor from 'react-visibility-sensor';

const GetReady = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Web',
                topics: [
                    'ML and AI for enhancing cyber defense',
                    'Network security and penetration testing',
                    'Secure erasure code-based cloud storage system',
                    'Infrastructure-as-Code to automate environment buildouts',
                    'Adoption of secure web protocols',
                    'Prioritizing the protection of sensitive data and personal information',
                ],
            },
            {
                title: 'Mobile',
                topics: [
                    'Protecting mobile app user data and privacy',
                    'Mobile app security testing and evaluation',
                    'Security for mobile app back-end systems and infrastructure',
                    'Compliance and regulatory requirements for mobile app security',
                    'ML and AI for mobile app security',
                ],
            },
            {
                title: 'Major updates',
                topics: [
                    'Zero trust security strategy',
                    'Multi-factor authentication',
                    'Data localization and data sovereignty',
                    '5G core to cloud security',
                    'Career',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <p className='getReady_item--title'>{item.title}</p>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li key={`getReady_li-${i + item}`} className='getReady_li'>{item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <VisibilitySensor partialVisibility={true}>
            {({ isVisible }) =>
                <div className='getReady_arrows'>
                    <div className={`getReady_wrap black ${isVisible ? 'visible' : 'invisible'}`}>
                        <div className='container getReady'>
                            <h2 className='getReady_title'>What is the event about?</h2>
                            <div className='getReady_block'>
                                {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </VisibilitySensor>
    );
};

export default GetReady;